export default __webpack_public_path__ + "static/Border-White-Bottom-b8c1874904ad45e050f5be2a4d6a39bf.png";